import React, { useState, useEffect } from 'react';
import Button from 'web/components/Button';
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import * as moment from "moment";

import { FormDetailWrapper, ButtonWrapper } from 'web/pages/account/registration/corporate-Registration-Styled'
import { stateConvert } from 'web/components/utils/stateAbbreviation';

export default ({ props, backBtnCallBack, submitCallBack, pageLanguageContents }) => {
  const [acknowledgeState, setAcknowledgeState] = useState(false);
  const [authorizeState, setAuthorizeState] = useState(false);
  const [subscriptionText, setSubscriptionText] = useState()
  const storedGuestBasicInfo = localStorage.getItem('guestBasicInfo');
  const guestBasicInfo = (storedGuestBasicInfo && storedGuestBasicInfo !== '')
    ? JSON.parse(storedGuestBasicInfo)
    : {};

  let hearAbout
  if ((props?.values?.modeOfContact === 'Other')) {
    hearAbout = props?.values?.modeOfContactOther
  } else if (props.values?.modeOfContact || guestBasicInfo?.hearAboutUs) {
    hearAbout = props.values?.modeOfContact || guestBasicInfo?.hearAboutUs
  }
  useEffect(() => {
    if (props.values?.appliedPromoCodeDetails?.promoCode) {
      let tempValue = props.values?.appliedPromoCodeDetails
      let promoName = tempValue?.promoCode
      let promoNumber = tempValue?.timeSpanForBenefits?.number
      let promoPeriod = tempValue?.timeSpanForBenefits?.timeDMY
      let nextBilling = tempValue?.chargedDate
      let nextBillingFormatted = moment(nextBilling).format('MM/DD/YYYY')
      let subsTextString = `Great News! Promo Code '${promoName}' applied for ${promoNumber} free ${promoPeriod?.toLowerCase()}s! Your card will not be charged until ${nextBillingFormatted}.`
      setSubscriptionText(subsTextString)
    }
  }, [props])

  // let address = props.values.line1?.trim() ?? guestBasicInfo.line1.trim()
  // if (props.values?.line2 && props.values.line2 !== '') address = address + ', ' + props.values.line2.trim()
  let address = "";
  if (props.values && props.values.line1) {
    address = `${props.values.line1?.trim()} ${props.values.line2 ? props.values.line2 : ""}`.trim();
  } else {
    address = `${guestBasicInfo?.line1?.trim()} ${guestBasicInfo?.line2 ? guestBasicInfo?.line2 : ""}`.trim();
  }

  const scubscription = () => {
    return (
      <div className='col-md-12 col-sm-12'>
        {localStorage.getItem('subscriptionCardNumber') && localStorage.getItem('subscriptionCardNumber') !== '' ? (
          <>
            <div className='description '>
              <h6>{pageLanguageContents?.Arrow3_Review[31]?.Subcription}</h6>
            </div>
            <div className='text-left description'>
              <p>{pageLanguageContents?.Arrow3_Review[32]?.Sub_Name}</p><p> : {localStorage.getItem('subscriptionCardName')}</p>
            </div>
            <div className='text-left description'>
              <p>{pageLanguageContents?.Arrow3_Review[33]?.Sub_Number}</p><p>  : **** **** **** {localStorage.getItem('subscriptionCardNumber')}</p>
            </div>
          </>
        ) : ('')
        }
      </div>
    )
  }

  const diverseTrackData = (diverseSelectedData) => {
    let tempData = diverseSelectedData?.map(data => (data.label || data.category)).join(", ")
    if (tempData.length > 20) tempData = tempData.substring(0, 20).concat('...')
    return tempData
  }

  const diverseTrackDataFull = (diverseSelectedData) => {
    let tempData = diverseSelectedData?.map(data => (data.label || data.category)).join(", ")
    return tempData
  }

  return (
    <FormDetailWrapper>
      <div>
        <div className="row mx-0 mb-2">
          <div className="col-md-12 col-sm-12">
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[0]?.FullName}</p>
              <p> : {props.values.name || guestBasicInfo.fullName}</p>
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[1]?.CompanyName}</p>
              {/* <p title={props.values.companyName}>: {props.values.companyName !== "" ? (props.values.companyName?.length > 20 ? props.values.companyName?.substring(0, 20).concat("...") : props.values.companyName) : 'NA'}</p> */}
              {
                (guestBasicInfo?.companyName) ?
                  <p title={guestBasicInfo.companyName}>: {guestBasicInfo.companyName !== "" ? (guestBasicInfo.companyName?.length > 20 ? guestBasicInfo.companyName?.substring(0, 20).concat("...") : guestBasicInfo.companyName) : 'NA'}</p>
                  :
                  <p title={props.values.companyName}>: {props.values.companyName !== "" ? (props.values.companyName?.length > 20 ? props.values.companyName?.substring(0, 20).concat("...") : props.values.companyName) : 'NA'}</p>
              }

            </div>
            <div className="description ">
              <p>DBA</p>
              {/* <p title={props.values.DBAName}>: {props.values.DBAName !== "" ? (props.values.DBAName?.length > 20 ? props.values.DBAName?.substring(0, 20).concat("...") : props.values.DBAName) : 'NA'}</p> */}
              {
                (guestBasicInfo?.dba) ? <p title={guestBasicInfo.dba}>: {guestBasicInfo.dba !== "" ? (guestBasicInfo.dba?.length > 20 ? guestBasicInfo.dba?.substring(0, 20).concat("...") : guestBasicInfo.dba) : 'NA'}</p>
                  : <p title={props.values.DBAName}>: {props.values.DBAName !== "" ? (props.values.DBAName?.length > 20 ? props.values.DBAName?.substring(0, 20).concat("...") : props.values.DBAName) : 'NA'}</p>
              }
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[2]?.Address}</p>
              <p title={address}>: {address?.trim() !== "" ? (address?.length > 20 ? address?.substring(0, 20).concat("...") : address) : 'NA'}</p>
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[3]?.State}</p>
              <p> : {stateConvert(props.values.locationST || guestBasicInfo.state)}</p>
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[4]?.City}</p>
              <p> : {props.values.locationCity || guestBasicInfo.city}</p>
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[5]?.Zip}</p>
              <p> : {props.values.locationZip || guestBasicInfo.zip}</p>
            </div>
            <div className="description ">
              <p>{pageLanguageContents?.Arrow3_Review[6]?.Email}</p>
              {/* <p title={props.values.email}>: {props.values.email !== "" ? (props.values.email?.length > 20 ? props.values.email?.substring(0,20).concat("...") : props.values.email) : 'NA'}</p> */}
              {
                (guestBasicInfo?.email) ? <p title={guestBasicInfo.email}>: {guestBasicInfo.email !== "" ? (guestBasicInfo.email?.length > 20 ? guestBasicInfo.email?.substring(0, 20).concat("...") : guestBasicInfo.email) : 'NA'}</p>
                  : <p title={props.values.email}>: {props.values.email !== "" ? (props.values.email?.length > 20 ? props.values.email?.substring(0, 20).concat("...") : props.values.email) : 'NA'}</p>
              }
            </div>
          </div>
          <div className="col-md-12 col-sm-12">
            <div className="description ">
              {props.values.taxId !== "" && (
                <>
                  <p>{pageLanguageContents?.Arrow3_Review[7]?.Tax}</p>
                  <p> : ****{props.values.taxId.slice(props.values.taxId.length - 4)}</p>
                </>
              )}
            </div>
            {props.values.taxidLicense === "1" && (
              <>
                <div className="description ">
                  {props.values.drivingLicense !== "" && (
                    <>
                      <p>{pageLanguageContents?.Arrow3_Review[8]?.DriversLicense}</p>
                      <p> : ****{props.values.drivingLicense.slice(props.values.drivingLicense.length - 5)}</p>
                    </>
                  )}
                </div>
                <div className="description ">
                  {props.values.drivingLicenseState !== "" && (
                    <>
                      <p>DLS</p>
                      <p> : {stateConvert(props.values.drivingLicenseState)}</p>
                    </>
                  )}
                </div>
                <div className="description ">
                  {props.values.dob !== "" && (
                    <>
                      <p>{pageLanguageContents?.Arrow3_Review[9]?.Dob}</p>
                      <p> : {props.values.dob}</p>
                    </>
                  )}
                </div>
                <div className="description ">
                  {props.values.firstName !== "" && (
                    <>
                      <p>{pageLanguageContents?.Arrow3_Review[10]?.FirstName}</p>
                      <p> : {props.values.firstName}</p>
                    </>
                  )}
                </div>
                <div className="description ">
                  {props.values.lastName !== "" && (
                    <>
                      <p>{pageLanguageContents?.Arrow3_Review[11]?.LastName}</p>
                      <p> : {props.values.lastName}</p>
                    </>
                  )}
                </div>

              </>
            )}
            <div className="description ">
              <>
                <p>{pageLanguageContents?.Arrow3_Review[15]?.DNB}</p>
                <p> : {props.values.dnbNum !== "" ? props.values.dnbNum : 'NA'}</p>
              </>
            </div>
            <div className="description ">
              <>
                <p>Business Website URL</p>
                {/* <p title={props.values.businessUrl}>: {props.values.businessUrl !== "" ? (props.values.businessUrl?.length > 20 ? props.values.businessUrl?.substring(0, 20).concat("...") : props.values.businessUrl) : 'NA'}</p> */}
                {(guestBasicInfo?.businessURL) ? <p title={guestBasicInfo.businessURL}>: {guestBasicInfo.businessURL !== "" ? (guestBasicInfo.businessURL?.length > 20 ? guestBasicInfo.businessURL?.substring(0, 20).concat("...") : guestBasicInfo.businessURL) : 'NA'}</p>
                  :
                  <p title={props.values.businessUrl}>: {props.values.businessUrl !== "" ? (props.values.businessUrl?.length > 20 ? props.values.businessUrl?.substring(0, 20).concat("...") : props.values.businessUrl) : 'NA'}</p>
                }
              </>
            </div>
            <div className="description ">
              <>
                <p>Business Description</p>
                {/* <p title={props.values.businessDesc}>: {props.values.businessDesc !== "" ? (props.values.businessDesc?.length > 20 ? props.values.businessDesc?.substring(0, 20).concat("...") : props.values.businessDesc) : 'NA'}</p> */}
                {
                  (guestBasicInfo?.businessDesc) ? <p title={guestBasicInfo.businessDesc}>: {guestBasicInfo.businessDesc !== "" ? (guestBasicInfo.businessDesc?.length > 20 ? guestBasicInfo.businessDesc?.substring(0, 20).concat("...") : guestBasicInfo.businessDesc) : 'NA'}</p>
                    :
                    <p title={props.values.businessDesc}>: {props.values.businessDesc !== "" ? (props.values.businessDesc?.length > 20 ? props.values.businessDesc?.substring(0, 20).concat("...") : props.values.businessDesc) : 'NA'}</p>
                }
              </>
            </div>
            <div className="description " style={{ alignItems: 'baseline' }}>
              <>
                <p>Diverse Spend Tracking Selection</p>
                {/* {props?.values?.diverseSpendSelectedList && props?.values?.diverseSpendSelectedList?.length > 0 ?
                  <p style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>: <div className='diverse-spend-selected-style' title={diverseTrackDataFull(props?.values?.diverseSpendSelectedList)}> {diverseTrackData(props?.values?.diverseSpendSelectedList)}</div></p>
                  :
                  <p>: NA</p>
                } */}
                {
                  (guestBasicInfo?.diverseTrackingResponses && guestBasicInfo?.diverseTrackingResponses.length > 0) ?
                    <p style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}> : <div className='diverse-spend-selected-style' title={diverseTrackDataFull(guestBasicInfo.diverseTrackingResponses)}> {diverseTrackData(guestBasicInfo.diverseTrackingResponses)}</div></p>
                    : <>
                      {

                        props?.values?.diverseSpendSelectedList && props?.values?.diverseSpendSelectedList?.length > 0 ?
                          <p style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>: <div className='diverse-spend-selected-style' title={diverseTrackDataFull(props?.values?.diverseSpendSelectedList)}> {diverseTrackData(props?.values?.diverseSpendSelectedList)}</div></p>
                          :
                          <p>: NA</p>

                      }
                    </>
                }
              </>
              {/* )} */}
            </div>
            <div className="description ">
              {hearAbout && (
                <>
                  <p>How Did You Hear About Us?</p>
                  <p>: {hearAbout}</p>
                </>
              )}
            </div>
            <div className="description ">
              {props?.values?.appliedPromoCodeDetails?.promoCode && (
                <>
                  <p>Promo Code/Referral Code</p>
                  <p>: {props?.values?.appliedPromoCodeDetails?.promoCode}</p>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="row mx-0 ">
          <div className="col-12">
            <div className="description ">
              <h6 style={{ margin: '25px 0px 10px 0' }}>{pageLanguageContents?.Arrow3_Review[16]?.AccountType} : {props?.values?.reseller === 'active' ? 'Broker' : props?.values?.buyerSellerOption || 'Broker'}</h6>
            </div>
          </div>
        </div>
        <div className="row mx-0 mb-3  ">
          <div className="col-md-12 col-sm-12 mb-4">
            {!localStorage.getItem("sellerDebitCardNumber") ? (
              <>{props.values.bankAccount && <>
                <div className="description ">
                  <h6>{pageLanguageContents?.Arrow3_Review[23]?.Bank}</h6>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[24]?.Name}</p>
                  <p> : {props.values.accountHolderName}</p>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[25]?.Account}</p>
                  <p>
                    {" "}
                    : **** **** ****
                    {props.values.bankAccount.slice(
                      props.values.bankAccount.length - 4
                    )}
                  </p>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[26]?.Routing}</p>
                  <p>
                    {" "}
                    : **** **** ****
                    {props.values.bankRouting.slice(
                      props.values.bankRouting.length - 4
                    )}
                  </p>
                </div>
              </>}
              </>
            ) : (
              <>
                <div className="description ">
                  <h6>{pageLanguageContents?.Arrow3_Review[27]?.Debit_cardDetails}</h6>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[29]?.Card_Name}</p>
                  <p> : {localStorage.getItem("sellerDebitCardName")}</p>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[30]?.Card_Number}</p>
                  <p>
                    {" "}
                    : **** **** **** {localStorage.getItem("sellerDebitCardNumber")}
                  </p>
                </div>
              </>
            )}
          </div>

          {localStorage.getItem("creditCardNumber") && localStorage.getItem("creditCardNumber") !== "" ? (
            <>
              <div className="col-md-12 col-sm-12 mb-4">
                <div className="description ">
                  <h6>{pageLanguageContents?.Arrow3_Review[28]?.Debit_credit}</h6>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[29]?.Card_Name}</p>
                  <p> : {localStorage.getItem("creditCardName")}</p>
                </div>
                <div className="description ">
                  <p>{pageLanguageContents?.Arrow3_Review[30]?.Card_Number}</p>
                  <p>
                    {" "}
                    : **** **** ****{" "}
                    {localStorage.getItem("creditCardNumber")}
                  </p>
                </div>
              </div>
              {scubscription()}
            </>
          ) :
            (localStorage.getItem("buyerDebitCardNumber") && localStorage.getItem("buyerDebitCardNumber") !== "") ?
              (
                <>
                  <div className="col-md-12 col-sm-12 mb-4">
                    <div className="description ">
                      <h6>{pageLanguageContents?.Arrow3_Review[28]?.Debit_credit}</h6>
                    </div>
                    <div className="description ">
                      <p>{pageLanguageContents?.Arrow3_Review[29]?.Card_Name}</p>
                      <p> : {localStorage.getItem("buyerDebitCardName")}</p>
                    </div>
                    <div className="description ">
                      <p>{pageLanguageContents?.Arrow3_Review[30]?.Card_Number}</p>
                      <p>
                        {" "}
                        : **** **** **** {localStorage.getItem("buyerDebitCardNumber")}
                      </p>
                    </div>
                  </div>
                  {scubscription()}
                </>
              ) :
              (
                <>
                  {scubscription()}
                </>
              )
          }
        </div>
        <div className="row mx-0 mb-4">
          {subscriptionText &&
            <div style={{ fontSize: '18px', fontFamily: "latomedium" }}>
              <p style={{ color: '#27911B', fontWeight: 'bold', padding: '0 15px' }}>{subscriptionText}</p>
            </div>
          }

          <div className="col-md-12 col-sm-12">
            <div style={{ fontSize: '18px', fontFamily: "latomedium" }}>
              {props.values.reseller === "active" &&
                <p>Total: $249 plus taxes </p>}
              {props.values.reseller !== "active" &&
                <p>Total: $79 plus taxes </p>}
            </div>

            <div className="account-type-option ">
              {props.values.reseller === "active" && <>
                <CheckboxInput
                  name="locationCharge"
                  label="I hereby accept and authorize that I will be charged a monthly subscription fee of $249 plus taxes. The start of this charge will commence after the promo or referral term concludes, if a promo code or referral code has been applied."
                  handleSelect={(name, label, e) => {
                    setAcknowledgeState(e)
                  }}
                />
              </>}
              {props.values.reseller !== "active" && <>
                <CheckboxInput
                  name="locationCharge"
                  label="I hereby accept and authorize that I will be charged a monthly subscription fee of $79 plus taxes. The start of this charge will commence after the promo or referral term concludes, if a promo code or referral code has been applied."
                  handleSelect={(name, label, e) => {
                    setAcknowledgeState(e)
                  }}
                />
              </>}

              <div style={{ display: 'flex' }}>
                <CheckboxInput
                  name="authorize"
                  label={''}
                  handleSelect={(name, label, e) => {
                    setAuthorizeState(e)
                  }}
                />
                <div style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
                  window.open(process.env.REACT_APP_WEB_URL + 'terms-of-use', "_blank")
                }}>I hereby acknowledge and agree to this website’s terms and conditions.</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ButtonWrapper className="last-step">
        <Button
          type="app-green-button submitBtn "
          handleClick={() => {
            backBtnCallBack();
          }}
        >
          {pageLanguageContents?.Arrow3_Review[34]?.Back}
        </Button>
        <Button
          type="app-green-button submitBtn "
          disabled={acknowledgeState && authorizeState ? false : true}
          handleClick={() => {
            submitCallBack();
          }}
        >
          {pageLanguageContents?.Arrow3_Review[35]?.Submit}
        </Button>
      </ButtonWrapper>
    </FormDetailWrapper>
  );
};
